module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_c('b', [_vm._v("SONG OF SELF-PITY")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("The song of self-pity is written in the soul.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Crying for the worth we need—the worth that makes us whole.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Rage in the evening")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("For the power we don’t have.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Tears in the morning")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("For praise we never gave.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Little birds atwitter")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("So happy to be alive.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Puppy dogs a-scratchin’")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("To the cosmic jive.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Pride masks the shame,")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("The ache in our hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Are we human refuse,")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Losers from the start?")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Every moment of sorrow")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Little birds sing with glee.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Should we waste the gift of life")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Given to us all for free?")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("We are the poor")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("So sadly on the dole,")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Blinded to a better life—")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Need we pay this toll?")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("The song of self-pity is written in the soul.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Crying for the worth we need—we need to make us whole.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342c6632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface_b.vue
// module id = 90
// module chunks = 0